/* byLivia — page catégorie : le texte tapé dans le hero s'affiche sur CHAQUE bijou de la grille,
   sur sa vraie plaque vierge et avec ses cotes (métachamp custom.gravure_config). Le client voit
   son prénom sur les 22 modèles avant même d'ouvrir une fiche, et il repart avec : le texte et le
   style suivent jusqu'à la fiche produit (?g= &f=, voir perso.js).
   Les modèles dont la zone gravable est trop courte pour ce texte restent sur leur photo produit
   et sont estompés : on ne promet pas une gravure qui serait refusée au panier. */
(function () {
  'use strict';

  function boot() {
    var P = window.byliviaPerso;
    var field = document.querySelector('[data-cpg-try]');
    if (!P || !field) return;
    var cards = Array.prototype.slice.call(document.querySelectorAll('[data-cpg-perso]'));
    if (!cards.length) return;

    var input = field.querySelector('[data-cpg-input]');
    var note = field.querySelector('[data-cpg-note]');
    var chips = Array.prototype.slice.call(field.querySelectorAll('[data-cpg-font]'));
    var ctx = document.createElement('canvas').getContext('2d');
    var state = { font: 'kaushan', loaded: false };
    /* Styles réellement proposés au client (ceux du hero), pas tous ceux que le moteur sait dessiner. */
    var offered = chips.map(function (c) { return c.getAttribute('data-cpg-font'); });

    /* ---------- Haut de page : la pointe écrit le prénom sur la gourmette ----------
       La plaque vierge d'une gourmette (collection-perso-hero) : le texte est posé par le moteur
       (P.placeText), puis écrit par la pointe de l'atelier (P.writer, partagé avec la landing).
       À l'arrivée : un prénom d'exemple ; puis celui que tape le visiteur, lettre après lettre. */
    var choose = field.querySelector('[data-cpg-choose]');
    var stReady = false;
    var st = (function (el) {
      if (!el || !P.writer) return null;
      var cfg;
      try { cfg = JSON.parse(el.getAttribute('data-config') || '{}'); } catch (e) { return null; }
      var pw = parseFloat((cfg.preview || {}).w || 45) / 100;
      var img = el.querySelector('img'), overlay = el.querySelector('[data-perso-overlay]');
      if (!overlay) return null;
      return {
        cfg: cfg, d: P.dims(cfg), img: img,
        s: { stage: el, overlay: overlay, img: img, zoom: Math.min(1.6, Math.max(1, 0.66 / pw)) },
        w: P.writer(el, overlay),
        demo: el.getAttribute('data-demo') || 'Alexandre', text: '', font: ''
      };
    })(document.querySelector('[data-cpg-stage]'));
    function stPlace() {
      var f = P.FONTS[st.font] || P.FONTS.kaushan;
      var r = P.fit(ctx, st.text, f.css, st.d.zoneW, st.d.zoneH, st.d.ppm);
      P.placeText(st.s, st.cfg.preview || {}, st.d, r, f, st.text);
    }
    function stUpdate(raw) {
      if (!st || !stReady) return;
      var font = state.font;
      var shown = P.normalize(raw || st.demo, font);
      var mode = shown === st.text && font === st.font ? 'none' : !st.text ? 'demo' : font !== st.font ? 'font' : raw ? 'type' : 'demo';
      st.text = shown; st.font = font;
      stPlace();
      st.w.write(shown, mode);
    }
    /* Photo de la plaque chargée après coup : on recale le texte (et la pointe). */
    if (st && st.img && !st.img.complete) st.img.addEventListener('load', function () { if (stReady && st.text) { stPlace(); st.w.redraw(); } });
    if (choose) choose.addEventListener('click', function (e) {
      var grid = document.getElementById('grille');
      if (!grid) return;
      e.preventDefault();
      grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    var scenes = cards.map(function (el) {
      var cfg = null;
      try { cfg = JSON.parse(el.getAttribute('data-config') || '{}'); } catch (e) { cfg = null; }
      var link = el.closest('a');
      return {
        el: el, cfg: cfg,
        img: el.querySelector('img'),
        overlay: el.querySelector('[data-perso-overlay]'),
        card: link, href: link ? link.getAttribute('href') : ''
      };
    }).filter(function (s) { return s.cfg && s.cfg.preview; });
    if (!scenes.length) return;

    /* La grille sait graver : le champ peut s'afficher. */
    field.hidden = false;

    /* Les photos de plaque ne descendent qu'au premier texte tapé. */
    function loadPlates() {
      if (state.loaded) return;
      state.loaded = true;
      scenes.forEach(function (s) {
        if (!s.img || s.img.getAttribute('src')) return;
        s.img.addEventListener('load', paint);
        s.img.setAttribute('src', s.img.getAttribute('data-src'));
      });
    }

    function linkFor(href, text) {
      if (!href || !text) return href;
      return href + (href.indexOf('?') > -1 ? '&' : '?') + 'g=' + encodeURIComponent(text) + '&f=' + encodeURIComponent(state.font);
    }

    function paint() {
      var raw = P.sanitize(input ? input.value : '').replace(/\s+/g, ' ').trim();
      if (raw) loadPlates();
      var f = P.FONTS[state.font] || P.FONTS.kaushan;
      var text = P.normalize(raw, state.font);
      var fits = 0;

      scenes.forEach(function (s) {
        if (!raw) {
          s.el.classList.remove('is-on');
          if (s.card) {
            s.card.classList.remove('is-dim');
            s.card.setAttribute('href', s.href);
          }
          return;
        }
        var d = P.dims(s.cfg);
        var r = P.fit(ctx, text, f.css, d.zoneW, d.zoneH, d.ppm);
        var ok = r.capMm >= d.minMm;
        if (ok) {
          fits++;
          P.placeText({ stage: s.el, overlay: s.overlay, img: s.img }, s.cfg.preview || {}, d, r, f, text);
        }
        s.el.classList.toggle('is-on', ok);
        if (s.card) {
          s.card.classList.toggle('is-dim', !ok);
          s.card.setAttribute('href', ok ? linkFor(s.href, text) : s.href);
        }
      });

      if (note) {
        if (!raw) {
          note.textContent = '';
        } else if (fits === scenes.length) {
          /* « nos X modèles » seulement si toute la page se grave au texte. */
          var all = document.querySelectorAll('.cpg__card').length;
          note.textContent = '« ' + text + ' » tient sur ' + (all === scenes.length ? 'nos ' + scenes.length + ' modèles' : 'les ' + scenes.length + ' modèles gravés au texte de cette page') + '. Choisissez le vôtre.';
        } else {
          /* Un style plus compact ferait-il mieux ? Le dire vaut mieux que de laisser le client
             croire que son prénom ne passe pas. */
          var best = null;
          offered.forEach(function (k) {
            var cf = P.FONTS[k];
            if (!cf) return;
            var t2 = P.normalize(raw, k);
            var n = 0;
            scenes.forEach(function (s) {
              var dd = P.dims(s.cfg);
              if (P.fit(ctx, t2, cf.css, dd.zoneW, dd.zoneH, dd.ppm).capMm >= dd.minMm) n++;
            });
            if (!best || n > best.n) best = { key: k, label: cf.label, n: n };
          });
          var tip = best && best.n > fits ? ' En ' + best.label + ', ' + (best.n === scenes.length ? 'les ' + scenes.length + ' passent' : best.n + ' passent') + '.' : '';
          if (fits > 0) {
            note.textContent = '« ' + text + ' » tient sur ' + fits + (fits > 1 ? ' modèles' : ' seul modèle') + ' sur ' + scenes.length + ' dans ce style.' + tip;
          } else {
            note.textContent = 'Trop long pour nos plaques dans ce style.' + (tip || ' Raccourcissez le texte.');
          }
        }
      }
      if (raw && P.remember) P.remember(text, state.font);
      if (choose) choose.hidden = !raw;
      stUpdate(raw);
    }

    if (input) {
      input.addEventListener('input', function () {
        var clean = P.sanitize(input.value);
        if (clean !== input.value) {
          var pos = (input.selectionStart || clean.length) - (input.value.length - clean.length);
          input.value = clean;
          try { input.setSelectionRange(pos, pos); } catch (e) { /* champ non focalisé */ }
        }
        paint();
      });
    }
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        state.font = c.getAttribute('data-cpg-font');
        chips.forEach(function (o) { o.setAttribute('aria-pressed', o === c ? 'true' : 'false'); });
        paint();
      });
    });
    window.addEventListener('resize', paint);

    /* Le client arrive d'une landing ou revient d'une fiche : son texte est déjà là. */
    if (input && !input.value && P.handoff) {
      var from = P.handoff();
      if (from.text) {
        input.value = from.text.slice(0, parseInt(input.getAttribute('maxlength') || '24', 10));
        if (from.font && P.FONTS[from.font]) {
          state.font = from.font;
          chips.forEach(function (o) { o.setAttribute('aria-pressed', o.getAttribute('data-cpg-font') === from.font ? 'true' : 'false'); });
        }
      }
    }

    /* La gourmette du haut s'écrit une fois les polices prêtes (sinon la mesure serait fausse). */
    function fontsReady() { stReady = true; paint(); }
    P.loadFonts().then(fontsReady, fontsReady);
    paint();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
